import React, { useContext } from "react";
import { Box } from "@material-ui/core";
import SigviewIcon from "../../components/Common/SigviewIcon";
import SigviewTypography from "../../components/Common/SigviewTypography";
import { ThemeContext } from "../../contexts/ThemeContext";

function SigviewIconsButton(props) {
  const {
    onClick = () => {},
    title = "",
    iconName = "",
    customClassName = "",
    direction = "row", // "row" or "column"
    iconPosition = "right", // "left" or "right"
    outerStyle = {},
    iconStyle = {},
    textStyle = {},
    color = "#fff",
    // gap = "4px",
  } = props;
  const { state: themeState } = useContext(ThemeContext);
  const themeColors = themeState.themes[themeState.activeTheme];

  const outerBox = {
    display: "flex",
    flexDirection: direction,
    justifyContent: "space-evenly",
    alignItems: "center",
    height: "32px", // increased for proper centering
    // padding: "0 12px",
    borderRadius: "20px",
    backgroundColor: themeColors["primaryColor"],
    color,
    fontWeight: 500,
    cursor: "pointer",
    // gap,
    ...outerStyle,
  };

  const innerBoxText = {
    fontSize: "14px",
    height: "auto",
    color,
    alignItems: "center",
    margin: "0px 0px 0px 5px",
    fontWeight: 500,
    cursor: "pointer",
    ...textStyle,
  };
  const innerBoxIcon = {
    fontSize: "18px",
    color,
    cursor: "pointer",
    hoverColor: color || themeColors["secondaryColor"],
    // gap:"4px",
    ...iconStyle,
  };

  const IconComponent = (
    <SigviewIcon
      className={`material-icons-outlined ${customClassName}`}
      iconName={iconName}
      style={innerBoxIcon}
    />
  );

  const TextComponent = (
    <SigviewTypography customClassName={customClassName} style={innerBoxText}>
      {title}
    </SigviewTypography>
  );

  return (
    <div className="SigviewIconButton">
      <Box className={customClassName} onClick={onClick} style={outerBox}>
        {iconPosition === "left" && IconComponent}
        {TextComponent}
        {iconPosition === "right" && IconComponent}
      </Box>
    </div>
  );
}

export default SigviewIconsButton;
